/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {OBJECT_TYPE} from '../../common/constants/object-type';

export function getLastVerbedProfileKey(prefix: 'lastEdited' | 'lastViewed', networkId: string, app: string): string {
  return 'adn' + _.upperFirst(prefix) + networkId + (app === 'ADVERTISING' ? '' : app);
}

export function hydrateLastVerbedEntries(rawEntries: any, canSeeUsers: boolean): any[] {
  if (!_.isObject(rawEntries)) {
    return [];
  }

  const source = _.isArray(rawEntries) ? rawEntries : _.values(rawEntries);
  let entries = _.cloneDeep(source);
  entries = _.filter(entries, (entry: any) => {
    return _.isObject(entry) && !!OBJECT_TYPE[(entry as any).objectType];
  });
  entries = _.map(entries, function(entry: any) {
    return {
      ...entry,
      objectType: OBJECT_TYPE[entry.objectType]
    };
  });
  return _.filter(entries, function(entry: any) {
    return !!entry.objectType && (canSeeUsers || entry.objectType !== OBJECT_TYPE.User);
  });
}
